
const menuDiv = {
    type: 'menuDivider'
}

export default menuDiv